import BaseModel from "../core/BaseModel";
export default class ControlMeasuresModel extends BaseModel {
  constructor() {
    super(
      {
        name: "control_measures",
        tableName: "control_measures",
        label: "Danh sách biện pháp kiểm soát",
        display_key: "name",
      },
      
      {
        check_box: {
          name: "check_box",
          label: " ",
          type: "Computed",
          custom: 'CheckBoxSelect',
          computed: (data) => {
            data.cb = '';
          },
          filter: {}
          // display: { list: true, add: false, edit: false }
        },
        stt: { 
          name: "stt", 
          label: "STT",
          class: 'center', 
          computed: (data, index) => {
            data.stt = index + 1;
          }
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        evaluation_form_name: {
          name: "evaluation_form_name",
          type: "String",
          label: "Phiếu đánh giá",
          filter: { type: "input", match: "contains" },
        },
        situation_name: {
          name: "situation_name",
          type: "String",
          label: "Tình huống",
          filter: { type: "input", match: "contains" },
        },
        danger_name: {
          name: "danger_name",
          type: "String",
          label: "Mối nguy",
          filter: { type: "input", match: "contains" },
        },
        name: {
          name: "name",
          type: "String",
          label: "Biện pháp",
          filter: { type: "input", match: "contains" },
        },
        type : {
          name: 'type', 
          type: "Selection", 
          // custom: 'Selection',
          label: 'Loại',
          // class: 'center',
          options: [
            {label: "Lặp lại",value: "LOOP"},
            {label: "Có thời hạn",value: "TIME"}
          ],
          // filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
        },
        implementer_text: {
          name: "implementer_text",
          type: "String",
          label: "Phân công thực hiện",
          filter: { type: "input", match: "contains" },
        },
        date_end_project: {
          name: "date_end_project",
          type: "Date",
          label: "Kết thúc dự án",
          filter: { type: 'DateRange', match: 'contains'},
        },
        frequency_text: {
          name: "frequency_text",
          type: "String",
          label: "Tần xuất lặp lại",
        },
        checker_text: {
          name: "checker_text",
          type: "String",
          label: "Người kiểm tra BPKS",
          filter: { type: "input", match: "contains" },
        },
        status : {
          name: 'status', 
          type: "Selection", 
          label: 'Trạng thái biện pháp',
          // class: 'center',
          options: [
            {label: "Đề xuất",value: "WAITING",style: 'color: #333333;'},
            {label: "Đã duyệt",value: "APPROVE",style: 'color: #0086C4;'},
            {label: "Không duyệt",value: "NOT_APPROVE",style: 'color: #F5564E;'},
            {label: "Đã hủy",value: "CANCEL",style: 'color: #F5564E;'},
            {label: "Mới",value: "NEW",style: 'color: #333333;'},
            {label: "Đang thực hiện",value: "INPROCESS",style: 'color: #179DA8;'},
            {label: "Tạm hoãn",value: "PENDING",style: 'color: #CFA71A;'},
            {label: "Kết thúc",value: "DONE",style: 'color: #00973C;'},
          ],
          filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối"
        },
        // deleted: {
        //   name: "deleted",
        //   label: "Xóa",
        //   type: "Checkbox",
        //   display: false,
        // },
      }
    );
  }
}
